export default "__VITE_ASSET__CYL91WPO__"